// True when the server listed this field's draft key in body[data-clear-local-storage]
// (jQuery parses that attribute into an array). The server lists drafts it just saved or
// rejected, and the page-level clear deletes them asynchronously, so a field must not
// restore a listed draft that IndexedDB still returns. Extracted so it can be unit-tested
// without stubbing jQuery/window (see local_draft_cleared_by_server.test.mjs).
export function draftClearedByServer(clearList, storageKey) {
  return Array.isArray(clearList) && clearList.includes(storageKey)
}
